import { Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import { ParticipantCourseList, ParticipantCourseQueryFilter, ParticipantCourseQueryFilterDefaultValues } from '../../course/participant-course-list';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { NoResultsComponent } from '../../no-results/no-results.component';
import { MatAccordion } from '@angular/material/expansion';
import { faGrip, faList } from '@fortawesome/free-solid-svg-icons';
import { CourseService } from 'src/app/services/course.service';
import { FileService } from 'src/app/services/file.service';
import { TagsService } from 'src/app/services/tag-service.service';
import { AuthService } from 'src/app/services/auth.service';
import { TranslationService } from 'src/app/services/translation.service';
import { LanguageService } from 'src/app/services/language.service';

@Component({
    selector: 'app-course-listing',
    templateUrl: './course-listing.component.html',
    styleUrls: ['./course-listing.component.scss'],
    standalone: false
})

export class CourseListingComponent {

  courseList: ParticipantCourseList[] = [];
  totalRecords: number = 0;
  columnsToDisplay = [
    'name',
    'description',
    'program',
    'enrollment',
    'status',
  ]
  tags: any[] = [];
  participantCourseStatus: any[] = [];
  pageEvent!: PageEvent;
  @ViewChild('paginator') paginator!: MatPaginator;
  @ViewChild('noResults') noResults!: NoResultsComponent;
  @ViewChild('submitButton') submitButton!: ElementRef;
  information: string = '';
  queryFilter: ParticipantCourseQueryFilter = ParticipantCourseQueryFilterDefaultValues();
  @ViewChild(MatAccordion) accordion!: MatAccordion;
  loggedInUserPublicId: string = '';
  gridIcon = faGrip;
  listIcon = faList;
  message = ''
  translation: any;

  constructor(public courseservice: CourseService,
    private fileservice: FileService,
    private authservice: AuthService,
    private translationservice: TranslationService,
    private languageService: LanguageService)
  {
  }

  ngOnInit() {
    this.loggedInUserPublicId = this.authservice.getUserLoginData().publicId;

    this.translationservice.getTranslation().subscribe({
      next: (data) => {
        this.translation = data;
        this.message = this.translation['noCourseText'];
      }
    });

    this.queryFilter.PageSize = 5;
    this.searchWithFilters();
  }

  searchWithFilters()
  {
    this.queryFilter.PageSize = 5;
    this.queryFilter.CourseLanguage = this.languageService.getCurretnLang();
    this.courseservice.getRecomendedCoursesForParticipantDashboard(this.queryFilter).subscribe({
      next: (data) => {
        let headers = data.headers.get('x-pagination');
        if (headers) {
          let parsedHeaders = JSON.parse(headers);
          this.totalRecords = parsedHeaders.TotalCount;
          this.noResults.setTotal(this.totalRecords);
        }
        this.courseList = data.body ? data.body : [];

        this.courseList.forEach(course => {

          if (course.courseThumbnailIconId) {
            this.openThumbnailImage(course.courseThumbnailIconId).then(url => {
              course.thumbnailUrl = url;
            }).catch(error => {
              console.log(error);
            });

          }
        });
      },
      error: (error) => {
        console.log(error);
      },
      complete: () => { }
    });
  }

  handleFavouriteClick() {
    this.searchWithFilters();
  }

  @HostListener('document:keypress', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent): void {
    if (event.key === 'Enter') {
    this.submitButton.nativeElement.click();
    event.preventDefault();
    }
  }

  handlePageEvent(e: PageEvent) {
    this.pageEvent = e;
    this.queryFilter.PageNumber=e.pageIndex
    this.searchWithFilters();
  }

  public openThumbnailImage(id: any): Promise<string> {
    return new Promise((resolve, reject) => {
      this.fileservice.downloadFile(id).subscribe({
        next: (response) => {
          resolve(response.url);
        },
        error: (error) => {
          reject(error);
        }
      });
    });
  }

  getProgressPercent(course: ParticipantCourseList): number {
    const status = (course.enrollmentStatus || '').replace(/\s+/g, '');
    if (status === 'Completed') {
      return 100;
    }
    if (status === 'InProgress') {
      return 40;
    }
    return 0;
  }

  getProgressLabel(course: ParticipantCourseList): string {
    const status = (course.enrollmentStatus || '').replace(/\s+/g, '');
    if (status === 'Completed') {
      return this.translation?.['completedText'] || 'Completed';
    }
    if (status === 'InProgress') {
      return this.translation?.['inProgressText'] || 'In progress';
    }
    return this.translation?.['notStartedText'] || 'Not started';
  }

  getStatusClass(course: ParticipantCourseList): string {
    const status = (course.enrollmentStatus || '').replace(/\s+/g, '');
    if (status === 'Completed') {
      return 'course-row__status--completed';
    }
    if (status === 'InProgress') {
      return 'course-row__status--in-progress';
    }
    return 'course-row__status--not-started';
  }

}
